export default __webpack_public_path__ + "static/O0307-451f671aff90caa6f92a01bb4d6f8aa5.png";